export default function StatusBadge({
  label,
  tone = "neutral",
}) {
  const styles = {
    success: {
      background: "#dcfce7",
      border: "1px solid #86efac",
      color: "#166534",
    },
    warning: {
      background: "#fef3c7",
      border: "1px solid #fde68a",
      color: "#92400e",
    },
    danger: {
      background: "#fee2e2",
      border: "1px solid #fecaca",
      color: "#991b1b",
    },
    info: {
      background: "#eff6ff",
      border: "1px solid #bfdbfe",
      color: "#1d4ed8",
    },
    neutral: {
      background: "#f8fafc",
      border: "1px solid #e2e8f0",
      color: "#475569",
    },
  };

  return (
    <span
      style={{
        padding: "4px 9px",
        borderRadius: 999,
        fontSize: 11,
        fontWeight: 900,
        whiteSpace: "nowrap",
        ...(styles[tone] || styles.neutral),
      }}
    >
      {label}
    </span>
  );
}